import NewsContainer from "./NewsContainer";
import CreateNewsContainer from "./CreateNewsContainer";
import DeleteNewsContainer from "./DeleteNewsContainer";
import ViewMoreNewsContainer from "./ViewMoreNewsContainer";

export {
  NewsContainer,
  CreateNewsContainer,
  DeleteNewsContainer,
  ViewMoreNewsContainer,
};
